import Logger from 'application/Shared/Utils/Debug';
import axios from 'axios';
import { useEffect, useState } from 'react';

interface ListObjectsCommandOutput {
    Contents?: {
        Key?: string;
        LastModified?: Date;
        ETag?: string;
        Size?: number;
        StorageClass?: string;
        Owner?: {
            DisplayName?: string;
            ID?: string;
        };
    }[];
    CommonPrefixes?: {
        Prefix?: string;
    }[];
    Delimiter?: string;
    EncodingType?: string;
    IsTruncated?: boolean;
    Marker?: string;
    MaxKeys?: number;
    Name?: string;
    NextMarker?: string;
    Prefix?: string;
}

export function useFetchManifests() {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<ListObjectsCommandOutput | null>(null);
    // calling refetchData will force a rerender on the hook
    const [shouldRefetchData, setShouldRefetch] = useState({});

    const refetchData = () => setShouldRefetch({});

    useEffect(() => {
        const { CancelToken } = axios;
        const { token: cancelToken } = CancelToken.source();

        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.get('/workato/manifests', {
                    cancelToken,
                    params: {}
                });
                setData(response.data?.data?.fileNames);
            } catch (error) {
                setError(
                    'Error fetching customer connections. Please try again later.'
                );
                Logger.error('Error fetching customer connections.', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [shouldRefetchData]);

    return { data, error, loading, refetchData };
}
